export const DEV_ARTICLE_BOOKMARK_FIXTURE_PARAM =
  "dev_article_bookmark_fixture";

/**
 * Returns the requested local bookmark state for visual review routes.
 * Native builds and non-development web builds always return null.
 */
export function getDevArticleBookmarkFixtureState(): boolean | null {
  if (!__DEV__ || typeof window === "undefined") return null;

  try {
    const fixture = new URLSearchParams(window.location.search).get(
      DEV_ARTICLE_BOOKMARK_FIXTURE_PARAM,
    );
    if (fixture === "saved") return true;
    if (fixture === "unsaved") return false;
  } catch {
    // Ignore malformed or unavailable browser URL state in development.
  }

  return null;
}

export function hasDevArticleBookmarkFixture(): boolean {
  return getDevArticleBookmarkFixtureState() !== null;
}
